// import React, { useEffect, useState } from "react";
// import SuitabilityBar from "../../../components/suitabilityBar";
// import { connect, useDispatch, useSelector } from "react-redux";
// import { FormGroup, Input, InputGroup, Table, Tooltip } from "reactstrap";
// import {
// 	ArrowRight,
// 	ChevronDown,
// 	Sliders,
// 	Star,
// 	Info,
// 	Share2,
// 	Loader as LoaderIcon,
// 	X,
// 	Search
// } from "react-feather";
// import { RouteComponentProps, withRouter } from "react-router-dom";
// import { IApplicationState } from "../../../redux/reducers";
// import Loader from "../../../components/loader";
// import { IIngredient } from "../../../interfaces/ingredient";
// import { IPaginateList, IPagination } from "../../../interfaces/pagination";
// import ingredientImagePlaceholder from "../../../assets/images/olive-ingredient-icon.png";
// import "../../../assets/scss/pages/dashboard/_dashlist.scss";
// import ingredientService from "../../../services/ingredientService";
// import config from "../../../utils/config";
// import { routes } from "../../routes";
// import Pagination from "../../../components/pagination";
// import { paginateAction } from "../../../redux/actions/pagination/pagination";
// import { Dispatch } from "redux";
// import { ingredients } from "../../../redux/actions/actionContants";
// import { sampleIngredients } from "../exampleData/ingredientSample";
// import ProgressGradient from "../../../components/common/progressGradient";
// import { toCamelCase } from "../../../utils/string";
// import { getIngredientImagePlaceholder } from "../../../utils/ingredient";
// import ReactImageFallback from "react-image-fallback";
// import { ImageSkeleton, TableSkeleton } from "../../../utils/ghostUI";
// import userService from "../../../services/userService";
// import { IUser } from "../../../interfaces/user";
// import notification from "../../../utils/notification";
// import { setSearchTerm } from "../../../redux/actions/ingredients/ingredientActions";
// import { PAGINATION_META_DEFAULT } from "../../../utils/constants";

// interface IProps extends RouteComponentProps {
// 	starredIngredients: any[];
// 	profile: IUser | undefined;
// 	ingredients: IPaginateList<IIngredient[]>;
// 	allIngredients?: boolean;
// 	showStarredIngredients?: boolean;
// 	handleStarredContent: () => void;
// 	getUserProfile: () => Promise<any>;
// 	getStarredIngredients: () => Promise<any>;
// 	fetchIngredients: () => Promise<any>;
// 	searchIngredient: (term: string, text?: string, page?: number) => Promise<any>;
// 	paginate: (page: number) => void;
// 	starIngredient: (id: string, isStarred: boolean) => Promise<any>;
// }

// const ALLERGENS = [
// 	"ShellFish",
// 	"Eggs",
// 	"Milk",
// 	"Soya",
// 	"Tree Nuts",
// 	"Fish",
// 	"Peanut",
// 	"Wheat",
// 	"Sesame",
// 	"Mustard",
// 	"Sulphites"
// ];

// const CATEGORIES = [
// 	"Additives",
// 	"Blends",
// 	"Dairy-based",
// 	"Fats, Oils",
// 	"Flavors & Salts",
// 	"Fruits & Vegetables",
// 	"Functional",
// 	"Grains, Fiber, Flours",
// 	"Nutrients",
// 	"Processing Aids",
// 	"Proteins",
// 	"Sweeteners"
// ];

// const IngredientList: React.FC<IProps> = ({
// 	ingredients: { list, pagination },
// 	paginate,
// 	...props
// }) => {
// 	const [loading, setLoading] = useState<boolean>(false);
// 	const [filterMenu, toggleFilterMenu] = useState<string>();
// 	const [marketFilters, setMarketFilters] = useState<string[]>([]);
// 	const [manufacturerFilters, setManufacturerFilters] = useState<string[]>([]);
// 	const [costFilter, setCostFilter] = useState<string | undefined>();
// 	const [allergenFilters, setAllergenFilters] = useState<string[]>([]);
// 	const [categoryFilters, setCategoryFilters] = useState<string[]>([]);
// 	const [plantBasedFilter, setPlantBasedFilter] = useState<string | undefined>();
// 	const [roiTooltip, setRoiTooltip] = useState<boolean>(false);
// 	const [isSupplier, setIsSupplier] = useState<boolean>(
// 		props.profile?.company.subscription_type == "supplier"
// 	);
// 	// const [searchTerm, setSearchTerm] = useState<string>("");
// 	const [show, setShow] = useState<boolean>(false);
// 	const [searchIngredients, setSearchIngredients] = useState<IIngredient[]>([]);
// 	const [searchPagination, setSearchPagination] = useState<IPagination>(PAGINATION_META_DEFAULT);
// 	// Setting copy of packages for cost demo
// 	const [ingredientsWCost, setIngredientsWCost] = useState<IIngredient[]>();
// 	const searchTerm = useSelector((state: IApplicationState) => state.ingredient.searchTerm);
// 	const dispatch = useDispatch();

// 	useEffect(() => {
// 		setLoading(true);
// 		Promise.all([
// 			props.getStarredIngredients(),
// 			props.allIngredients ? props.fetchIngredients() : () => {}
// 		]).finally(() => {
// 			setLoading(false);
// 		});
// 	}, [pagination.page]);

// 	useEffect(() => {
// 		if (!props.profile) {
// 			props.getUserProfile();
// 		}
// 		if (searchTerm) {
// 			setLoading(true);
// 			triggerSearch(searchTerm);
// 		}
// 	}, []);

// 	const handleFilterChange = (filter: string, type: string) => {
// 		switch (type) {
// 			case "cost":
// 				costFilter != filter ? setCostFilter(filter) : setCostFilter(undefined);
// 				break;
// 			case "plant-based":
// 				plantBasedFilter != filter ? setPlantBasedFilter(filter) : setPlantBasedFilter(undefined);
// 				break;
// 			case "allergens":
// 				!allergenFilters?.includes(filter)
// 					? setAllergenFilters(allergenFilters?.concat(filter))
// 					: setAllergenFilters(allergenFilters?.filter((f) => f != filter));
// 				break;
// 			case "category":
// 				!categoryFilters?.includes(filter)
// 					? setCategoryFilters(categoryFilters?.concat(filter))
// 					: setCategoryFilters(categoryFilters?.filter((f) => f != filter));
// 				break;
// 		}
// 		setSearchPagination((prev) => ({ ...prev, page: 1 }));
// 	};

// 	const triggerSearch = async (search: string, page: number = 1) => {
// 		setLoading(true);
// 		try {
// 			const response = await props.searchIngredient(search, "paginated", page);
// 			setSearchIngredients(Array.isArray(response.data) ? response.data : []);
// 			setSearchPagination(response.meta || PAGINATION_META_DEFAULT);
// 		} catch {
// 			setSearchIngredients([]);
// 			setSearchPagination(PAGINATION_META_DEFAULT);
// 		} finally {
// 			setLoading(false);
// 		}
// 	};

// 	async function handleSearchChange(e: any) {
// 		const search = e.target.value;
// 		// setSearchTerm(search);
// 		dispatch(setSearchTerm(search));
// 		setSearchPagination(PAGINATION_META_DEFAULT);
// 		if (search) {
// 			setLoading(true);
// 			triggerSearch(search);
// 		} else {
// 			setSearchIngredients([]);
// 			setLoading(false);
// 		}
// 	}

// 	const clearSearch = () => {
// 		setSearchIngredients([]);
// 		dispatch(setSearchTerm(""));
// 		setSearchPagination(PAGINATION_META_DEFAULT);
// 	};

// 	async function handleStarIngredient(id: string, hasStar: boolean) {
// 		setLoading(true);
// 		try {
// 			await props.starIngredient(id, hasStar);
// 			notification.ingredient(
// 				`Ingredient ${hasStar ? "removed from" : "added as"} starred ingredients`
// 			);
// 		} finally {
// 			setLoading(false);
// 		}
// 	}

// 	// Currently just generates a random number of dollar signs 1-3
// 	const getDollarSigns = (num: number) => {
// 		let signs = "";
// 		for (let i = 0; i <= num; i++) {
// 			signs += " $ ";
// 		}
// 		return <span className={"cost"}>{signs}</span>;
// 	};

// 	const setIngredientDemoCosts = () => {
// 		const wCost = list;
// 		wCost.forEach((item) => {
// 			item.roi = parseInt(Math.random().toFixed(2));
// 			item.cost = Math.floor(Math.random() * 3).toPrecision(2);
// 			item.price_per_unit = Math.floor(Math.random() * (1000 - 100) + 100) / 100;
// 		});
// 		setIngredientsWCost(wCost);
// 	};

// 	// For sample ingredients right now
// 	const filterIngredients = () => {
// 		let filtered = sampleIngredients;

// 		if (costFilter) {
// 			filtered = filtered.sort((a: any, b: any) => {
// 				if (costFilter == "Premium") return b?.cost - a?.cost;
// 				return a?.cost - b?.cost;
// 			});
// 		}
// 		if (categoryFilters.length > 0) {
// 			filtered = filtered.filter((p) => {
// 				let hasCategory = false;
// 				p.categories?.forEach((r) => {
// 					if (categoryFilters.includes(r)) hasCategory = true;
// 				});
// 				return hasCategory;
// 			});
// 		}
// 		if (allergenFilters.length > 0) {
// 			filtered = filtered.filter((p) => {
// 				let hasAllergen = false;
// 				p.allergens?.forEach((r) => {
// 					if (allergenFilters.includes(r)) hasAllergen = true;
// 				});
// 				return !hasAllergen;
// 			});
// 		}
// 		if (plantBasedFilter) {
// 			filtered = filtered.filter((p) => {
// 				return plantBasedFilter == "No" ? !p.plant_based : p.plant_based;
// 			});
// 		}
// 		return filtered;
// 	};

// 	const activePagination = searchTerm ? searchPagination : pagination;
// 	const paginationProps = {
// 		page: activePagination.page,
// 		size: activePagination.size,
// 		pages: activePagination.pages,
// 		total: activePagination.total
// 	};

// 	const handlePageChanges = (page: number) => {
// 		if (searchTerm) {
// 			triggerSearch(searchTerm, page);
// 			setSearchPagination((prev) => ({ ...prev, page }));
// 		} else {
// 			paginate(page);
// 		}
// 	};

// 	return (
// 		<div className="dash-list ">
// 			{/* Display filters and pagination if on ingredients page showing all ingredients */}
// 			{props.allIngredients ? (
// 				<div style={{ paddingTop: 45 }}>
// 					<span className="title mb-2">
// 						<h4 className="mr-2 font-weight-semibold">All Ingredients: {loading ? <LoaderIcon className={"fa-spin"} /> : activePagination.total}</h4>
// 						<h4 className="count color-bg-blue font-weight-normal">

// 						</h4>
// 						<FormGroup className="mb-0">
// 							<InputGroup className={`${show ? "active" : ""}`}>
// 								<div
// 									style={{
// 										display: "flex",
// 										border: "1px solid #CFDBE7",
// 										borderRadius: "4px",
// 										alignItems: "center",
// 										padding: "3px 5px",
// 										marginLeft: "8px",
// 										width: "250px",
// 										marginTop: "-3px"
// 									}}
// 								>
// 									<Search size="16" />
// 									<Input
// 										onChange={handleSearchChange}
// 										onFocus={() => setShow(true)}
// 										onBlur={() => setShow(false)}
// 										type="search"
// 										name="search-text"
// 										id="search-text"
// 										className="ml-2 border-0 w-100"
// 										autoComplete=""
// 										value={searchTerm}
// 									/>
// 									{searchTerm ? <X onClick={clearSearch} color={"#e85a73"} size={18} /> : <></>}
// 								</div>
// 							</InputGroup>
// 						</FormGroup>
//   <Pagination
// 							{...paginationProps}
// 							handlePageChange={(page) => {
// 								handlePageChanges(page);
// 							}}
// 						/>
// 					</span>

// 					<span className={"filters"}>
// 						<span className={"filter-title"}>
// 							<Sliders color={"#657280"} size={24} /> Filters:{" "}
// 						</span>
// 						{/* Market Filter */}
// 						<div
// 							className="filter"
// 							onMouseOver={() => toggleFilterMenu("cost")}
// 							onMouseLeave={() => toggleFilterMenu(undefined)}
// 						>
// 							<span className={costFilter != undefined ? "filter-menu active" : "filter-menu"}>
// 								Cost
// 								<ChevronDown size={16} />
// 							</span>
// 							{filterMenu == "cost" ? (
// 								<ul className="list-filters">
// 									<li
// 										className={costFilter == "Premium" ? "active" : ""}
// 										onClick={(e) => {
// 											handleFilterChange(e.currentTarget.innerHTML, "cost");
// 										}}
// 									>
// 										Premium
// 									</li>
// 									<li
// 										className={costFilter == "Low Cost" ? "active" : ""}
// 										onClick={(e) => {
// 											handleFilterChange(e.currentTarget.innerHTML, "cost");
// 										}}
// 									>
// 										Low Cost
// 									</li>
// 								</ul>
// 							) : (
// 								""
// 							)}
// 						</div>
// 						<div
// 							className="filter"
// 							onMouseOver={() => toggleFilterMenu("plant-based")}
// 							onMouseLeave={() => toggleFilterMenu(undefined)}
// 						>
// 							<span
// 								className={plantBasedFilter != undefined ? "filter-menu active" : "filter-menu"}
// 							>
// 								Plant Based
// 								<ChevronDown size={16} />
// 							</span>
// 							{filterMenu == "plant-based" ? (
// 								<ul className="list-filters">
// 									<li
// 										className={plantBasedFilter == "Yes" ? "active" : ""}
// 										onClick={(e) => {
// 											handleFilterChange(e.currentTarget.innerHTML, "plant-based");
// 										}}
// 									>
// 										Yes
// 									</li>
// 									<li
// 										className={plantBasedFilter == "No" ? "active" : ""}
// 										onClick={(e) => {
// 											handleFilterChange(e.currentTarget.innerHTML, "plant-based");
// 										}}
// 									>
// 										No
// 									</li>
// 								</ul>
// 							) : (
// 								""
// 							)}
// 						</div>
// 						<div
// 							className="filter"
// 							onMouseOver={() => toggleFilterMenu("allergens")}
// 							onMouseLeave={() => toggleFilterMenu(undefined)}
// 						>
// 							<span className={allergenFilters.length > 0 ? "filter-menu active" : "filter-menu"}>
// 								Allergen
// 								<ChevronDown size={16} />
// 							</span>
// 							{filterMenu == "allergens" ? (
// 								<ul className="list-filters">
// 									{ALLERGENS.map((a, index: number) => (
// 										<li
// 											key={index}
// 											className={allergenFilters.includes(a) ? "active" : ""}
// 											onClick={(e) => {
// 												handleFilterChange(e.currentTarget.innerHTML, "allergens");
// 											}}
// 										>
// 											{a}
// 										</li>
// 									))}
// 								</ul>
// 							) : (
// 								""
// 							)}
// 						</div>
// 						<div
// 							className="filter"
// 							onMouseOver={() => toggleFilterMenu("category")}
// 							onMouseLeave={() => toggleFilterMenu(undefined)}
// 						>
// 							<span className={categoryFilters.length > 0 ? "filter-menu active" : "filter-menu"}>
// 								Category
// 								<ChevronDown size={16} />
// 							</span>
// 							{filterMenu == "category" ? (
// 								<ul className="list-filters">
// 									{CATEGORIES.map((c, index: number) => (
// 										<li
// 											key={index}
// 											className={categoryFilters.includes(c) ? "active" : ""}
// 											onClick={(e) => {
// 												handleFilterChange(e.currentTarget.innerHTML, "category");
// 											}}
// 										>
// 											{c}
// 										</li>
// 									))}
// 								</ul>
// 							) : (
// 								""
// 							)}
// 						</div>
//
// 						<div style={{ height: "35px" }} className="pl-3">
// 							<div className="d-flex align-items-center">
// 								<input
// 									type="radio"
// 									id="starred_ingredient"
// 									checked={props.showStarredIngredients}
// 									onClick={props.handleStarredContent}
// 								/>
// 								<label className="mb-0 pl-1" htmlFor="starred_ingredient">
// 									show starred ingredients
// 								</label>
// 							</div>
// 						</div>
// 						{(costFilter ||
// 							allergenFilters.length ||
// 							categoryFilters.length ||
// 							plantBasedFilter) && (
// 							<div
// 								style={{ height: "35px" }}
// 								className="pl-3"
// 								onClick={() => {
// 									setCostFilter(undefined);
// 									setAllergenFilters([]);
// 									setCategoryFilters([]);
// 									setPlantBasedFilter(undefined);
// 									setSearchPagination((prev) => ({ ...prev, page: 1 }));
// 								}}
// 							>
// 								<div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
// 									<u>reset filters</u>
// 								</div>
// 							</div>
// 						)}
// 					</span>
// 				</div>
// 			) : (
// 				<></>
// 			)}
// 			 <div className="table-container">
// 			<Table borderless>
// 				<thead>
// 					<tr key="ingredient-list-header">
// 						<th></th>
// 						<th>Name</th>
// 						<th></th>
// 						<th>Manufacturer</th>
// 						<th>Price/Unit</th>
// 						<th>
// 							ROI
// 							<Info
// 								id="roi"
// 								href="#"
// 								size={16}
// 								style={{
// 									marginLeft: 5,
// 									color: "#fff",
// 									borderRadius: "50%",
// 									backgroundColor: "#3f65f1"
// 								}}
// 							/>
// 							<Tooltip
// 								className="simple-tooltip"
// 								isOpen={roiTooltip}
// 								placement="top"
// 								target="roi"
// 								toggle={() => setRoiTooltip(!roiTooltip)}
// 							>
// 								Proprietary cost-benefit based on consumer spend against supply chain action
// 							</Tooltip>
// 						</th>
// 						<th></th>
// 						<th></th>
// 					</tr>
// 				</thead>
// 				{loading ? (
// 					<TableSkeleton />
// 				) : (
// 					<tbody>
// 						{/* { (props.allIngredients ? list : props.starredIngredients).map((i: any, index: any) =>  ( */}
// 						{(!(
// 							costFilter != undefined ||
// 							plantBasedFilter != undefined ||
// 							allergenFilters.length > 0 ||
// 							categoryFilters.length > 0
// 						)
// 							? searchTerm
// 								? searchIngredients
// 								: props.showStarredIngredients
// 								? props.starredIngredients
// 								: props.allIngredients
// 								? ingredientsWCost
// 									? ingredientsWCost
// 									: list
// 								: props.starredIngredients
// 							: []
// 						)?.map((i: any, index: number) => (
// 							<tr
// 								onClick={() => props.history.push(`${routes.INGREDIENTS}/${i.id}`)}
// 								className="list-row"
// 								key={i.id + index}
// 							>
// 								<td>
// 									<ReactImageFallback
// 										initialImage={<ImageSkeleton className={"table-img-ghost"} />}
// 										src={config.api.endpoints.ingredients.ingredientImage(i.jf_display_name)}
// 										fallbackImage={getIngredientImagePlaceholder()}
// 										alt="Ingredient Image"
// 										className="mr-2 ml-2"
// 										style={{ borderRadius: 6 }}
// 									/>
// 								</td>
// 								<td>{toCamelCase(i.name)}</td>
// 								<td>
// 									{props.starredIngredients.find((item) => item.id === i.id) ? (
// 										<Star
// 											style={{ cursor: "pointer" }}
// 											className="star"
// 											color="#f4a850"
// 											size={16}
// 											fill="#f4a850"
// 											onClick={(e) => {
// 												handleStarIngredient(i.id, true);
// 												e.stopPropagation();
// 											}}
// 										/>
// 									) : (
// 										<Star
// 											style={{ cursor: "pointer" }}
// 											className="star"
// 											color="#657280"
// 											size={16}
// 											onClick={(e) => {
// 												handleStarIngredient(i.id, false);
// 												e.stopPropagation();
// 											}}
// 										/>
// 									)}
// 								</td>
// 								<td>{i.manufacturer?.name}</td>
// 								<td
// 									onClick={(e) => {
// 										e.stopPropagation();
// 										if (!(i.price || i.price_per_unit)) props.history.push(routes.INTEGRATIONS);
// 									}}
// 									style={{
// 										color: `${i.price || i.price_per_unit ? "default" : "#cedbe9"}`,
// 										cursor: "pointer"
// 									}}
// 								>
// 									{i.price || i.price_per_unit ? (
// 										`$${Number(i.price)?.toFixed(2) || Number(i.price_per_unit)?.toFixed()}`
// 									) : (
// 										<Share2 size={16} color={"#cedbe9"} />
// 									)}
// 								</td>
// 								<td>
// 									<span style={{ color: "#65728085" }}>Coming Soon</span>
// 								</td>
// 								<td>
// 									<i className={`${i.country?.alpha_2?.toLowerCase() || "us"} flag list-flag`}></i>
// 								</td>
// 								<td align="right">
// 									<span className="action">
// 										<ArrowRight size={17} color={"#4974f3"} className="mr-1" />
// 										View
// 									</span>
// 								</td>
// 							</tr>
// 						))}
// 					</tbody>
// 				)}
// 			</Table>
// 			</div>
// 		</div>
// 	);
// };

// const mapStateToProps = (state: IApplicationState) => ({
// 	starredIngredients: state.ingredient.starred,
// 	ingredients: state.ingredient.ingredients,
// 	profile: state.user.profile
// });

// const mapDispatchToProps = {
// 	getStarredIngredients: () => ingredientService.getStarredIngredients(),
// 	fetchIngredients: () => ingredientService.getIngredients(),
// 	searchIngredient: (term: string, text?: string, page?: number) =>
// 		ingredientService.searchIngredient(term, text, page),
// 	paginate: (page: number) => (dispatch: Dispatch) => {
// 		dispatch(paginateAction(ingredients.PAGINATE_INGREDIENTS, page));
// 	},
// 	starIngredient: (id: string, isStarred: boolean) =>
// 		ingredientService.starIngredient(id, isStarred),
// 	getUserProfile: () => userService.getUserProfile()
// };

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IngredientList));
import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { FormGroup, Input, InputGroup, Table, Tooltip } from "reactstrap";
import {
	ArrowRight,
	ChevronDown,
	Sliders,
	Star,
	Info,
	Share2,
	Loader as LoaderIcon,
	X,
	Search
} from "react-feather";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { IApplicationState } from "../../../redux/reducers";
import { IIngredient } from "../../../interfaces/ingredient";
import { IPaginateList, IPagination } from "../../../interfaces/pagination";
import ingredientImagePlaceholder from "../../../assets/images/olive-ingredient-icon.png";
import "../../../assets/scss/pages/dashboard/_dashlist.scss";
import ingredientService from "../../../services/ingredientService";
import config from "../../../utils/config";
import { routes } from "../../routes";
import Pagination from "../../../components/pagination";
import { paginateAction } from "../../../redux/actions/pagination/pagination";
import { Dispatch } from "redux";
import { ingredients } from "../../../redux/actions/actionContants";
import { toCamelCase } from "../../../utils/string";
import { getIngredientImagePlaceholder } from "../../../utils/ingredient";
import ReactImageFallback from "react-image-fallback";
import { ImageSkeleton, TableSkeleton } from "../../../utils/ghostUI";
import userService from "../../../services/userService";
import { IUser } from "../../../interfaces/user";
import notification from "../../../utils/notification";
import { setSearchTerm } from "../../../redux/actions/ingredients/ingredientActions";
import { PAGINATION_META_DEFAULT } from "../../../utils/constants";
import { useDebounce } from "../../../utils/hooks";

interface IProps extends RouteComponentProps {
	starredIngredients: any[];
	profile: IUser | undefined;
	ingredients: IPaginateList<IIngredient[]> & { cache: { [page: number]: IIngredient[] } };
	isLoaded: boolean;
	isStarredLoaded: boolean;
	allIngredients?: boolean;
	showStarredIngredients?: boolean;
	handleStarredContent: () => void;
	getUserProfile: () => Promise<any>;
	getStarredIngredients: () => Promise<any>;
	fetchIngredients: () => Promise<any>;
	searchIngredient: (term: string, text?: string, page?: number) => Promise<any>;
	paginate: (page: number) => void;
	starIngredient: (id: string, isStarred: boolean) => Promise<any>;
}

const ALLERGENS = [
	"ShellFish",
	"Eggs",
	"Milk",
	"Soya",
	"Tree Nuts",
	"Fish",
	"Peanut",
	"Wheat",
	"Sesame",
	"Mustard",
	"Sulphites"
];

const CATEGORIES = [
	"Additives",
	"Blends",
	"Dairy-based",
	"Fats, Oils",
	"Flavors & Salts",
	"Fruits & Vegetables",
	"Functional",
	"Grains, Fiber, Flours",
	"Nutrients",
	"Processing Aids",
	"Proteins",
	"Sweeteners"
];

const IngredientList: React.FC<IProps> = React.memo(
	({ ingredients, paginate, ...props }) => {
		const { list, pagination } = ingredients;
		const [loading, setLoading] = useState<boolean>(false);
		const [paginationLoading, setPaginationLoading] = useState<boolean>(false);
		const [filterMenu, toggleFilterMenu] = useState<string>();
		const [costFilter, setCostFilter] = useState<string | undefined>();
		const [allergenFilters, setAllergenFilters] = useState<string[]>([]);
		const [categoryFilters, setCategoryFilters] = useState<string[]>([]);
		const [plantBasedFilter, setPlantBasedFilter] = useState<string | undefined>();
		const [roiTooltip, setRoiTooltip] = useState<boolean>(false);
		const [show, setShow] = useState<boolean>(false);
		const [searchIngredients, setSearchIngredients] = useState<IIngredient[]>([]);
		const [searchPagination, setSearchPagination] = useState<IPagination>(PAGINATION_META_DEFAULT);
		const [ingredientsWCost, setIngredientsWCost] = useState<IIngredient[]>();
		const searchTerm = useSelector((state: IApplicationState) => state.ingredient.searchTerm);
		const dispatch = useDispatch();

		// Debounce search term to reduce API calls (500ms delay)
		const debouncedSearchTerm = useDebounce(searchTerm, 500);

		// Track if we've handled the initial search to avoid duplicate calls on mount
		const hasInitialSearchRef = useRef<boolean>(false);

		// AbortController ref to cancel previous requests
		const abortControllerRef = useRef<AbortController | null>(null);

		// Track the latest request ID to ignore stale responses
		const requestIdRef = useRef<number>(0);

		// Track last pagination click time to prevent rapid clicks
		const lastPaginationClickRef = useRef<number>(0);

		useEffect(() => {
			// Cancel any pending requests when pagination changes
			if (abortControllerRef.current) {
				abortControllerRef.current.abort();
			}

			// Create new abort controller for this request
			abortControllerRef.current = new AbortController();

			const currentPage = pagination.page;
			const skipIngredients = props.allIngredients && ingredients.cache && ingredients.cache[currentPage];
			const skipStarred = props.isStarredLoaded;

			if (skipIngredients && skipStarred) {
				setPaginationLoading(false);
				setLoading(false);
				return;
			}

			setPaginationLoading(true);
			setLoading(true);

			Promise.all([
				skipStarred ? Promise.resolve() : props.getStarredIngredients(),
				(props.allIngredients && !skipIngredients) ? props.fetchIngredients() : Promise.resolve()
			]).finally(() => {
				setPaginationLoading(false);
				setLoading(false);
			});

			// Cleanup function to abort request if component unmounts or pagination changes
			return () => {
				if (abortControllerRef.current) {
					abortControllerRef.current.abort();
				}
			};
		}, [pagination.page]);

		useEffect(() => {
			if (!props.profile) {
				props.getUserProfile();
			}

			// Cleanup function to abort any pending requests when component unmounts
			return () => {
				if (abortControllerRef.current) {
					abortControllerRef.current.abort();
				}
			};
		}, []);

		/**
		 * Trigger search API call
		 * Memoized with useCallback to prevent unnecessary re-renders
		 */
		const triggerSearch = useCallback(
			async (search: string | undefined, page: number = 1) => {
				// Handle null/undefined or empty search term
				const searchTerm = search?.trim() || "";
				if (!searchTerm) {
					setSearchIngredients([]);
					setSearchPagination(PAGINATION_META_DEFAULT);
					setLoading(false);
					return;
				}

				// Cancel previous search request
				if (abortControllerRef.current) {
					abortControllerRef.current.abort();
				}
				
				// Create new abort controller for this search
				abortControllerRef.current = new AbortController();
				
				// Generate unique request ID
				const currentRequestId = ++requestIdRef.current;

				setLoading(true);
				try {
					const response = await props.searchIngredient(searchTerm, "paginated", page);
					
					// Only update state if this is still the latest request
					if (currentRequestId === requestIdRef.current) {
						setSearchIngredients(Array.isArray(response.data) ? response.data : []);
						setSearchPagination(response.meta || PAGINATION_META_DEFAULT);
					}
				} catch (error) {
					// Only update state if this is still the latest request and not aborted
					if (currentRequestId === requestIdRef.current && (error as any)?.name !== 'AbortError') {
						setSearchIngredients([]);
						setSearchPagination(PAGINATION_META_DEFAULT);
					}
				} finally {
					// Only clear loading if this is still the latest request
					if (currentRequestId === requestIdRef.current) {
						setLoading(false);
					}
				}
			},
			[props.searchIngredient]
		);

		/**
		 * Trigger search when debounced search term changes
		 * This effect runs only after user stops typing for 500ms
		 * Handles both user input and initial mount with existing search term
		 */
		useEffect(() => {
			// Skip if this is the initial render and there's no search term
			// This prevents unnecessary API call on mount when no search exists
			if (!hasInitialSearchRef.current && !debouncedSearchTerm) {
				hasInitialSearchRef.current = true;
				return;
			}

			// Mark that we've handled at least one search
			hasInitialSearchRef.current = true;

			// Trigger search with debounced term (empty string will clear results)
			triggerSearch(debouncedSearchTerm, 1);
		}, [debouncedSearchTerm, triggerSearch]);

		const handleFilterChange = (filter: string, type: string) => {
			switch (type) {
				case "cost":
					costFilter != filter ? setCostFilter(filter) : setCostFilter(undefined);
					break;
				case "plant-based":
					plantBasedFilter != filter ? setPlantBasedFilter(filter) : setPlantBasedFilter(undefined);
					break;
				case "allergens":
					!allergenFilters?.includes(filter)
						? setAllergenFilters(allergenFilters?.concat(filter))
						: setAllergenFilters(allergenFilters?.filter((f) => f != filter));
					break;
				case "category":
					!categoryFilters?.includes(filter)
						? setCategoryFilters(categoryFilters?.concat(filter))
						: setCategoryFilters(categoryFilters?.filter((f) => f != filter));
					break;
			}
			setSearchPagination((prev) => ({ ...prev, page: 1 }));
		};

		/**
		 * Handle search input changes
		 * Updates the search term in Redux state immediately for UI responsiveness
		 * Actual API call is debounced via useEffect watching debouncedSearchTerm
		 */
		const handleSearchChange = useCallback(
			(e: React.ChangeEvent<HTMLInputElement>) => {
				const search = e.target.value;
				dispatch(setSearchTerm(search));
				// Reset pagination when search term changes
				setSearchPagination(PAGINATION_META_DEFAULT);

				// Clear results immediately if search is empty
				if (!search.trim()) {
					setSearchIngredients([]);
					setLoading(false);
				}
			},
			[dispatch]
		);
		const clearSearch = () => {
			setSearchIngredients([]);
			dispatch(setSearchTerm(""));
			setSearchPagination(PAGINATION_META_DEFAULT);
		};

		async function handleStarIngredient(id: string, hasStar: boolean) {
			setLoading(true);
			try {
				await props.starIngredient(id, hasStar);
				notification.ingredient(
					`Ingredient ${hasStar ? "removed from" : "added as"} starred ingredients`
				);
			} finally {
				setLoading(false);
			}
		}

		/**
		 * Determine the active data source based on current state
		 */
		const dataSource = useMemo(() => {
			if (searchTerm) {
				return searchIngredients;
			}
			if (props.showStarredIngredients) {
				return props.starredIngredients;
			}
			if (props.allIngredients) {
				return ingredientsWCost || list;
			}
			return props.starredIngredients;
		}, [
			searchTerm,
			searchIngredients,
			props.showStarredIngredients,
			props.starredIngredients,
			props.allIngredients,
			ingredientsWCost,
			list
		]);

		/**
		 * Apply filters to the data source
		 * Filters are applied in sequence: cost (sorting), plant-based, allergens (exclude), categories (include)
		 */
		const filteredData = useMemo(() => {
			if (!dataSource || !Array.isArray(dataSource)) {
				return [];
			}

			let filtered = [...dataSource];

			// Apply cost filter (sorting)
			if (costFilter === "Premium") {
				filtered = filtered.sort((a: any, b: any) => {
					const costA =
						parseFloat(a.cost) || parseFloat(a.price_per_unit) || parseFloat(a.price) || 0;
					const costB =
						parseFloat(b.cost) || parseFloat(b.price_per_unit) || parseFloat(b.price) || 0;
					return costB - costA; // Descending for Premium
				});
			} else if (costFilter === "Low Cost") {
				filtered = filtered.sort((a: any, b: any) => {
					const costA =
						parseFloat(a.cost) || parseFloat(a.price_per_unit) || parseFloat(a.price) || 0;
					const costB =
						parseFloat(b.cost) || parseFloat(b.price_per_unit) || parseFloat(b.price) || 0;
					return costA - costB; // Ascending for Low Cost
				});
			}

			// Apply plant-based filter
			if (plantBasedFilter === "Yes") {
				filtered = filtered.filter((item: any) => {
					// Handle both string and boolean values
					const plantBased = item.plant_based;
					return (
						plantBased === true ||
						plantBased === "Yes" ||
						plantBased === "yes" ||
						plantBased === "true"
					);
				});
			} else if (plantBasedFilter === "No") {
				filtered = filtered.filter((item: any) => {
					// Handle both string and boolean values
					const plantBased = item.plant_based;
					return (
						plantBased === false ||
						plantBased === "No" ||
						plantBased === "no" ||
						plantBased === "false" ||
						!plantBased
					);
				});
			}

			// Apply allergen filters (exclude items containing selected allergens)
			if (allergenFilters.length > 0) {
				filtered = filtered.filter((item: any) => {
					const itemAllergens = item.allergens || [];

					// Handle both array of strings and array of objects
					const allergenNames = itemAllergens
						.map((allergen: any) => {
							if (typeof allergen === "string") {
								return allergen;
							}
							if (allergen && typeof allergen === "object" && allergen.allergen) {
								return allergen.allergen;
							}
							return "";
						})
						.filter(Boolean);

					// Check if item contains any of the selected allergens (exclude if it does)
					return !allergenFilters.some((filterAllergen) => {
						// Case-insensitive comparison
						return allergenNames.some(
							(itemAllergen: string) => itemAllergen.toLowerCase() === filterAllergen.toLowerCase()
						);
					});
				});
			}

			// Apply category filters (include items matching selected categories)
			if (categoryFilters.length > 0) {
				filtered = filtered.filter((item: any) => {
					const itemCategories = item.categories || [];

					// Check if item matches any of the selected categories
					return categoryFilters.some((filterCategory) => {
						return itemCategories.some((itemCategory: any) => {
							const categoryName =
								typeof itemCategory === "string"
									? itemCategory
									: itemCategory?.name || itemCategory?.title || "";
							return categoryName.toLowerCase() === filterCategory.toLowerCase();
						});
					});
				});
			}

			return filtered;
		}, [dataSource, costFilter, plantBasedFilter, allergenFilters, categoryFilters]);

		const activePagination = searchTerm ? searchPagination : pagination;
		const paginationProps = {
			page: activePagination.page,
			size: activePagination.size,
			pages: activePagination.pages,
			total: activePagination.total
		};

		/**
		 * Handle pagination changes
		 * Uses debounced search term to ensure consistency with search results
		 * Prevents multiple rapid clicks by checking loading state and debouncing
		 */
		const handlePageChanges = useCallback(
			(page: number) => {
				// Prevent pagination changes while loading
				if (loading || paginationLoading) {
					return;
				}

				// Debounce pagination clicks (300ms minimum between clicks)
				const now = Date.now();
				if (now - lastPaginationClickRef.current < 300) {
					return;
				}
				lastPaginationClickRef.current = now;

				if (debouncedSearchTerm) {
					// For search results, use debounced term to maintain consistency
					triggerSearch(debouncedSearchTerm, page);
					setSearchPagination((prev) => ({ ...prev, page }));
				} else {
					// For regular ingredient list, use normal pagination
					setPaginationLoading(true);
					paginate(page);
				}
			},
			[debouncedSearchTerm, triggerSearch, paginate, loading, paginationLoading]
		);

		return (
			<div className="dash-list">
				{props.allIngredients ? (
					<div style={{ paddingTop: 45 }}>
						<div className="title mb-2">
							<h4 className="mr-2 font-weight-semibold">
								All Ingredients:
								{loading ? (
									<LoaderIcon className={"fa-spin"} />
								) : costFilter ||
									plantBasedFilter ||
									allergenFilters.length > 0 ||
									categoryFilters.length > 0 ? (
									filteredData.length
								) : (
									activePagination.total
								)}
							</h4>
							<h4 className="count color-bg-blue font-weight-normal"></h4>
							<FormGroup className="mb-0">
								<InputGroup className={`${show ? "active" : ""}`}>
									<div
										style={{
											display: "flex",
											border: "1px solid #CFDBE7",
											borderRadius: "4px",
											alignItems: "center",
											padding: "5px",
											marginLeft: "8px",
											width: "250px",
											marginTop: "-3px"
										}}
									>
										<Search size="16" />
										<Input
											onChange={handleSearchChange}
											onFocus={() => setShow(true)}
											onBlur={() => setShow(false)}
											type="search"
											name="search-text"
											id="search-text"
											className="ml-2 border-0 w-100"
											autoComplete=""
											value={searchTerm}
											placeholder="Search"
										/>
										{searchTerm ? <X onClick={clearSearch} color={"#e85a73"} size={18} /> : <></>}
									</div>
								</InputGroup>
							</FormGroup>
						</div>

						<span className={"filters"}>
							<span className={"filter-title"}>
								<Sliders color={"#657280"} size={24} /> Filters:{" "}
							</span>

							<div
								className="filter"
								onMouseOver={() => toggleFilterMenu("cost")}
								onMouseLeave={() => toggleFilterMenu(undefined)}
							>
								<span className={costFilter != undefined ? "filter-menu active" : "filter-menu"}>
									Cost
									<ChevronDown size={16} />
								</span>
								{filterMenu == "cost" ? (
									<ul className="list-filters">
										<li
											className={costFilter == "Premium" ? "active" : ""}
											onClick={(e) => {
												handleFilterChange(e.currentTarget.innerHTML, "cost");
											}}
										>
											Premium
										</li>
										<li
											className={costFilter == "Low Cost" ? "active" : ""}
											onClick={(e) => {
												handleFilterChange(e.currentTarget.innerHTML, "cost");
											}}
										>
											Low Cost
										</li>
									</ul>
								) : (
									""
								)}
							</div>

							<div
								className="filter"
								onMouseOver={() => toggleFilterMenu("plant-based")}
								onMouseLeave={() => toggleFilterMenu(undefined)}
							>
								<span
									className={plantBasedFilter != undefined ? "filter-menu active" : "filter-menu"}
								>
									Plant Based
									<ChevronDown size={16} />
								</span>
								{filterMenu == "plant-based" ? (
									<ul className="list-filters">
										<li
											className={plantBasedFilter == "Yes" ? "active" : ""}
											onClick={(e) => {
												handleFilterChange(e.currentTarget.innerHTML, "plant-based");
											}}
										>
											Yes
										</li>
										<li
											className={plantBasedFilter == "No" ? "active" : ""}
											onClick={(e) => {
												handleFilterChange(e.currentTarget.innerHTML, "plant-based");
											}}
										>
											No
										</li>
									</ul>
								) : (
									""
								)}
							</div>

							<div
								className="filter"
								onMouseOver={() => toggleFilterMenu("allergens")}
								onMouseLeave={() => toggleFilterMenu(undefined)}
							>
								<span className={allergenFilters.length > 0 ? "filter-menu active" : "filter-menu"}>
									Allergen
									<ChevronDown size={16} />
								</span>
								{filterMenu == "allergens" ? (
									<ul className="list-filters">
										{ALLERGENS.map((a, index: number) => (
											<li
												key={index}
												className={allergenFilters.includes(a) ? "active" : ""}
												onClick={(e) => {
													handleFilterChange(e.currentTarget.innerHTML, "allergens");
												}}
											>
												{a}
											</li>
										))}
									</ul>
								) : (
									""
								)}
							</div>

							<div
								className="filter"
								onMouseOver={() => toggleFilterMenu("category")}
								onMouseLeave={() => toggleFilterMenu(undefined)}
							>
								<span className={categoryFilters.length > 0 ? "filter-menu active" : "filter-menu"}>
									Category
									<ChevronDown size={16} />
								</span>
								{filterMenu == "category" ? (
									<ul className="list-filters">
										{CATEGORIES.map((c, index: number) => (
											<li
												key={index}
												className={categoryFilters.includes(c) ? "active" : ""}
												onClick={(e) => {
													handleFilterChange(e.currentTarget.innerHTML, "category");
												}}
											>
												{c}
											</li>
										))}
									</ul>
								) : (
									""
								)}
							</div>

							<div style={{ height: "35px" }} className="pl-3">
								<div className="d-flex align-items-center">
									<input
										type="checkbox"
										id="starred_ingredient"
										checked={props.showStarredIngredients}
										onChange={props.handleStarredContent}
									/>
									<label className="mb-0 pl-1" htmlFor="starred_ingredient">
										show starred ingredients
									</label>
								</div>
							</div>

							{(costFilter ||
								allergenFilters.length ||
								categoryFilters.length ||
								plantBasedFilter ||
								searchTerm ||
								props.showStarredIngredients) && (
									<div
										style={{ height: "35px" }}
										className="pl-3"
										onClick={() => {
											setCostFilter(undefined);
											setAllergenFilters([]);
											setCategoryFilters([]);
											setPlantBasedFilter(undefined);
											dispatch(setSearchTerm(""));
											if (props.showStarredIngredients) {
												props.handleStarredContent();
											}
											setSearchPagination((prev) => ({ ...prev, page: 1 }));
										}}
									>
										<div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
											<u>clear filters</u>
										</div>
									</div>
								)}
						</span>
					</div>
				) : null}

				{/* Table with horizontal scroll container */}
				<div className="table-container">
					<Table borderless className="ingredients-list-table">
						<thead>
							<tr key="ingredient-list-header">
								<th className="image-column"></th>
								<th className="name-column">Name</th>
								<th className="star-column">⭐</th>
								<th className="manufacturer-column">Manufacturer</th>
								<th className="price-column">Price/Unit</th>
								<th className="roi-column">
									ROI
									<Info
										id="roi"
										href="#"
										size={16}
										style={{
											marginLeft: 5,
											color: "#fff",
											borderRadius: "50%",
											backgroundColor: "#3f65f1"
										}}
									/>
									<Tooltip
										className="simple-tooltip"
										isOpen={roiTooltip}
										placement="top"
										target="roi"
										toggle={() => setRoiTooltip(!roiTooltip)}
									>
										Proprietary cost-benefit based on consumer spend against supply chain action
									</Tooltip>
								</th>
								<th className="flag-column">Country</th>
								<th className="spacer-column" style={{ width: "120px" }}>Actions</th>
							</tr>
						</thead>
						{loading ? (
							<TableSkeleton />
						) : (
							<tbody>
								{filteredData.length > 0 ? (
									filteredData.map((i: any, index: number) => (
										<tr
											onClick={() => props.history.push(`${routes.INGREDIENTS}/${i.id}`)}
											className="list-row"
											key={i.id + index}
										>
											<td className="image-column">
												<ReactImageFallback
													initialImage={<ImageSkeleton className={"table-img-ghost"} />}
													src={i.image_url || getIngredientImagePlaceholder()}
													fallbackImage={getIngredientImagePlaceholder()}
													alt="Ingredient Image"
													className="mr-2 ml-2"
													style={{ borderRadius: 6 }}
												/>
											</td>
											<td className="name-column">{toCamelCase(i.name)}</td>
											<td className="star-column">
												<div className="star-container">
													{(() => {
														const isStarred = props.starredIngredients.find(
															(item) => item.id === i.id
														);
														return isStarred ? (
															<Star
																style={{ cursor: "pointer" }}
																className="star"
																color="#f4a850"
																size={16}
																fill="#f4a850"
																onClick={(e) => {
																	handleStarIngredient(i.id, true);
																	e.stopPropagation();
																}}
															/>
														) : (
															<Star
																style={{ cursor: "pointer" }}
																className="star"
																color="#657280"
																size={16}
																onClick={(e) => {
																	handleStarIngredient(i.id, false);
																	e.stopPropagation();
																}}
															/>
														);
													})()}
												</div>
											</td>
											<td className="manufacturer-column">{i.manufacturer?.name}</td>
											<td
												className="price-column"
												onClick={(e) => {
													e.stopPropagation();
													if (!(i.price || i.price_per_unit))
														props.history.push(routes.INTEGRATIONS);
												}}
												style={{
													color: `${i.price || i.price_per_unit ? "default" : "#cedbe9"}`,
													cursor: "pointer"
												}}
											>
												{i.price || i.price_per_unit ? (
													`$${Number(i.price)?.toFixed(2) || Number(i.price_per_unit)?.toFixed()}`
												) : (
													<Share2 size={16} color={"#cedbe9"} />
												)}
											</td>
											<td className="roi-column">
												<span style={{ color: "#65728085" }}>Coming Soon</span>
											</td>
											<td className="flag-column">
												<i
													className={`${i.country?.alpha_2?.toLowerCase() || "us"} flag list-flag`}
												></i>
											</td>
											<td className="spacer-column" align="right">
												<span className="action">
													<ArrowRight size={17} color={"#4974f3"} className="mr-1" />
													View
												</span>
											</td>
										</tr>
									))
								) : (
									<tr>
										<td colSpan={8} style={{ textAlign: "center", padding: "40px" }}>
											<span style={{ color: "#657280" }}>
												{loading ? "Loading..." : "No ingredients match your filters"}
											</span>
										</td>
									</tr>
								)}
							</tbody>
						)}
					</Table>
				</div>

				{/* Pagination below the table */}
				{!costFilter && !plantBasedFilter && allergenFilters.length === 0 && categoryFilters.length === 0 && (
					<Pagination
						{...paginationProps}
						handlePageChange={(page) => handlePageChanges(page)}
						loading={loading || paginationLoading}
					/>
				)}
			</div>
		);
	}
);

const mapStateToProps = (state: IApplicationState) => ({
	starredIngredients: state.ingredient.starred,
	ingredients: state.ingredient.ingredients,
	isLoaded: state.ingredient.isLoaded,
	isStarredLoaded: state.ingredient.isStarredLoaded,
	profile: state.user.profile
});

const mapDispatchToProps = {
	getStarredIngredients: () => ingredientService.getStarredIngredients(),
	fetchIngredients: () => ingredientService.getIngredients(),
	searchIngredient: (term: string, text?: string, page?: number) =>
		ingredientService.searchIngredient(term, text, page),
	paginate: (page: number) => (dispatch: Dispatch) => {
		dispatch(paginateAction(ingredients.PAGINATE_INGREDIENTS, page));
	},
	starIngredient: (id: string, isStarred: boolean) =>
		ingredientService.starIngredient(id, isStarred),
	getUserProfile: () => userService.getUserProfile()
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IngredientList));
